// eslint-disable-next-line @tseslint/typedef
export const DATA_DISPLAY_TYPES = {
  string: "string",
  localizedString: "localizedString",
  "boolean": "boolean",
  edit: "edit",
  img: "img",
  status: "status",
  date: "date",
  duration: "duration",
  datePeriod: "datePeriod",
  timePeriod: "timePeriod"
} as const;
export type DataDisplayType = typeof DATA_DISPLAY_TYPES[keyof typeof DATA_DISPLAY_TYPES];
